import { Button, ConfigProvider, DatePicker, Flex, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import MyTimesheetTable from "./MyTimesheetTable";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as LeftArrowIcon } from "assets/icon/leftArrowIcon.svg";
import { ReactComponent as RightArrowIcon } from "assets/icon/rightArrowIcon.svg"; import dayjs from "dayjs";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import styles from "../styles/MyTimesheet.module.css";

const MyTimesheetCalendar = ({
    onDateChange = () => { },
    currentDate = "",
    columns = [],
    timesheetCalendar = [],
    transformTimesheetData = [],
    isUpdateMode,
    setIsUpdateMode = () => { },
    isView = false
}) => {
    const { t, i18n } = useTranslation();

    function localeFn() {
        if (i18n.language === 'en') {
            return localeEn
        } else {
            return {
                ...localeTh,
                lang: {
                    ...localeTh.lang,
                    yearFormat: "BBBB",
                    dateFormat: "D/M/BBBB",
                    cellYearFormat: "BBBB"
                }
            }
        }
    }

    const onPrevClick = () => {
        const prevMonth = dayjs(currentDate).subtract(1, 'month');
        onDateChange(prevMonth);
    };

    const onNextClick = () => {
        const nextMonth = dayjs(currentDate).add(1, 'month');
        onDateChange(nextMonth);
    };

    return (
        <Space size={25} direction="vertical">
            {!isView &&
                <Row justify={"end"}>
                    <Button
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                        icon={<CreateIcon style={{ fontSize: 16 }} />}
                        onClick={() => {
                            setIsUpdateMode((prevMode) => !prevMode);
                        }}
                    >
                        {isUpdateMode ? t("my_timesheet.label.cancel_update_timesheet") : t("my_timesheet.label.update_timesheet")}
                    </Button>
                </Row>
            }

            <Space direction="vertical" style={{ alignItems: "center" }}>
                <Flex justify="center">
                    <LeftArrowIcon
                        onClick={onPrevClick}
                        style={{ cursor: "pointer", alignSelf: "center", width: "8px" }} />
                    <ConfigProvider
                        theme={{
                            components: {
                                DatePicker: {
                                    colorBgContainer: "transparent",
                                }
                            }
                        }}
                    >
                        <DatePicker
                            allowClear={false}
                            value={currentDate}
                            onChange={onDateChange}
                            format={i18n.language == "en" ? "MMMM YYYY" : "MMMM BBBB"}
                            picker="month"
                            suffixIcon={null}
                            className={styles.datePicker}
                            style={{ width: "200px", textAlignLast: "center" }}
                            locale={localeFn()}
                        />

                    </ConfigProvider>
                    <RightArrowIcon
                        onClick={onNextClick}
                        style={{ cursor: "pointer", alignSelf: "center", width: "8px" }} />
                </Flex>
                <MyTimesheetTable
                    columns={columns}
                    timesheetCalendar={timesheetCalendar}
                    transformTimesheetData={transformTimesheetData}
                />
            </Space>
        </Space >
    )
}

export default MyTimesheetCalendar;